module.exports = __webpack_public_path__ + "img/bn3.3501432a.png";